let deleteDialogTrigger;
let restoreDeleteDialogFocus = true;

function deleteDialog() {
  return document.querySelector("[data-host-offer-delete-dialog]");
}

function openDeleteDialog(trigger) {
  const dialog = deleteDialog();
  const form = dialog?.querySelector("[data-host-offer-delete-form]");
  const heading = dialog?.querySelector("[data-host-offer-delete-heading]");
  const deleteUrl = trigger.dataset.hostOfferDeleteUrl;
  const title = trigger.dataset.hostOfferDeleteTitle;
  const titleTemplate = dialog?.dataset.hostOfferDeleteTitleTemplate;
  if (!dialog || !form || !heading || !deleteUrl || !title || !titleTemplate) return;

  form.setAttribute("action", deleteUrl);
  heading.textContent = titleTemplate.replace("__OFFER_TITLE__", () => title);
  deleteDialogTrigger = trigger;
  restoreDeleteDialogFocus = true;

  if (!dialog.open && typeof dialog.showModal === "function") {
    dialog.showModal();
  } else if (!dialog.open) {
    dialog.setAttribute("open", "");
  }
  dialog.querySelector("[data-host-offer-delete-cancel]")?.focus();
}

function closeDeleteDialog({ restoreFocus = true } = {}) {
  const dialog = deleteDialog();
  if (!dialog?.open) return;

  restoreDeleteDialogFocus = restoreFocus;
  if (typeof dialog.close === "function") {
    dialog.close();
  } else {
    dialog.removeAttribute("open");
    if (restoreFocus) deleteDialogTrigger?.focus();
  }
}

document.addEventListener("click", function (event) {
  const deleteOpen = event.target.closest?.("[data-host-offer-delete]");
  if (deleteOpen) {
    event.preventDefault();
    openDeleteDialog(deleteOpen);
    return;
  }

  if (event.target.closest?.("[data-host-offer-delete-close]")) {
    closeDeleteDialog();
    return;
  }

  const dialog = event.target.closest?.("[data-host-offer-delete-dialog]");
  if (dialog && event.target === dialog) closeDeleteDialog();
});

document.addEventListener("close", function (event) {
  if (!event.target.matches?.("[data-host-offer-delete-dialog]")) return;

  if (restoreDeleteDialogFocus) deleteDialogTrigger?.focus();
  restoreDeleteDialogFocus = true;
}, true);

document.addEventListener("turbo:before-render", function () {
  closeDeleteDialog({ restoreFocus: false });
});
